export const LARGE_DELIVERY_ITEMS_THRESHOLD = 6;
export const LARGE_DELIVERY_SUBTOTAL_THRESHOLD = 100;
export const LARGE_DELIVERY_DEFAULT_TIP = 15;
export const LARGE_DELIVERY_DEFAULT_DRIVERS = 1;
export const LARGE_DELIVERY_MIN_DRIVERS = 1;
export const LARGE_DELIVERY_MAX_DRIVERS = 5;
export const LARGE_DELIVERY_REASON = 'LARGE_ORDER';
export const LARGE_DELIVERY_TIP_CUSTOM = 'Custom';

export const LARGE_DELIVERY_TIP_OPTIONS = [
  {label: '0', value: 0},
  {label: '10%', value: 10},
  {label: '15%', value: 15},
  {label: '18%', value: 18},
  {label: '20%', value: 20},
  {label: 'Custom', value: LARGE_DELIVERY_TIP_CUSTOM}
];
